import script from "./ApplicationChecklistItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationChecklistItem.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationChecklistItem.vue?vue&type=style&index=0&id=065072a2&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065072a2"]])

export default __exports__